module.exports = __webpack_public_path__ + "static/media/other_documents_active.f3789959.svg";